module.exports = __webpack_public_path__ + "static/media/baner_ 118x3022.ce4e0ccb.png";